import React from 'react';

type HeaderProps = {
  children?: never;
};

const Header: React.FunctionComponent<HeaderProps> = () => null;

Header.displayName = 'Header';

export default Header;
